import { render } from "./AddFoodLimitComponent.vue?vue&type=template&id=0b68fd6a&scoped=true"
import script from "./AddFoodLimitComponent.vue?vue&type=script&lang=js"
export * from "./AddFoodLimitComponent.vue?vue&type=script&lang=js"

import "./AddFoodLimitComponent.vue?vue&type=style&index=0&id=0b68fd6a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b68fd6a"]])

export default __exports__